import {
  ICON_PROGRESS_CHECK, ICON_CHECK_CIRCLE_OUTLINE, ICON_PROGRESS_ALERT, ICON_ALERT_CIRCLE_OUTLINE,
} from '@doveit/bricks';
import { MembershipStatus } from '../domain/types';
import { PerformanceRating, RankType } from '../providers/api/dtos';
import { RankRule } from './components/agent-leaderboard-item/types';
import { GoalProgressColor } from './types';

export const membershipStatusBadgeIcon: Record<MembershipStatus, string> = {
  [MembershipStatus.UNDER_ACTIVATION]: ICON_PROGRESS_CHECK,
  [MembershipStatus.ACTIVE]: ICON_CHECK_CIRCLE_OUTLINE,
  [MembershipStatus.UNDER_REVOCATION]: ICON_PROGRESS_ALERT,
  [MembershipStatus.REVOKED]: ICON_ALERT_CIRCLE_OUTLINE,
};

export const RANKING_RULES: Record<RankType, RankRule[]> = {
  AGENT: [
    {
      maxRank: 3,
      color: 'warning',
      shownPosition: 3,
      label: 'Top',
    },
    {
      maxRank: 10,
      color: 'success',
      shownPosition: 10,
      label: 'Top',
    },
    {
      maxRank: 20,
      color: 'info',
      shownPosition: 20,
      label: 'Top',
    },
    {
      maxRank: 50,
      color: 'info',
      shownPosition: 50,
      label: 'Top',
    },
    {
      maxRank: Infinity,
      color: 'neutral',
      shownPosition: (rank) => rank,
      label: 'Posizione',
    },
  ],
  ROOKIE: [
    {
      maxRank: 3,
      color: 'warning',
      shownPosition: 3,
      label: 'Top',
    },
    {
      maxRank: 10,
      color: 'success',
      shownPosition: 10,
      label: 'Top',
    },
    {
      maxRank: Infinity,
      color: 'neutral',
      shownPosition: (rank) => rank,
      label: 'Posizione',
    },
  ],
};

export const configByPerformanceRating: Record<PerformanceRating, {
  color: GoalProgressColor,
  message: string,
}> = ({
  CRITICAL: {
    color: 'critical',
    message: "Non sei in linea con l'obiettivo.",
  },
  BELOW_EXPECTATIONS: {
    color: 'warning',
    message: "Non sei in linea con l'obiettivo.",
  },
  NEARLY_ON_TRACK: {
    color: 'info',
    message: "Sei quasi in linea con l'obiettivo.",
  },
  ON_TRACK: {
    color: 'info',
    message: "Sei in linea con l'obiettivo.",
  },
  ABOVE_EXPECTATIONS: {
    color: 'success',
    message: "Sei in linea con l'obiettivo.",
  },
});
